import type { StandardRequest } from '@/store';
import type { IAgentPosition } from '@/store/types';

import routes from '@/config/routes';
import { v3Get } from '@/api/axios.instance.V3';

const getAgentPositionListByClientId: StandardRequest<IAgentPosition[], { clientId: number }> = (payload, config) =>
  v3Get(routes.backendUrl.agentPosition.getByClientId + payload.clientId, config);

const getAgentPositionListByClientIdAndCountryIds: StandardRequest<
  IAgentPosition[],
  { clientId: number; countryIds: number[] }
> = (payload, config) =>
  v3Get(routes.backendUrl.agentPosition.getByClientIdAndCountryIds + payload.clientId, {
    ...config,
    params: { countryIds: payload.countryIds.join(',') },
  });

export const agentPositionApi = {
  getAgentPositionListByClientId,
  getAgentPositionListByClientIdAndCountryIds,
};
